import React from 'react';
import classes from '../EventsPage/EventsPage.module.css';
import EventsCards from '../../ReusableComponents/EventsCards/EventsCards';
import ListStatus from '../../ReusableComponents/ListStatus/ListStatus';
import img from '../../assets/eventsBg.jpg';
import PageHeader from '../../ReusableComponents/PageHeader/PageHeader';
import useInfiniteList from '../../CustomHooks/useInfiniteList';

// Declared outside the component so their identity is stable across renders.
const selectNews = (result) => result?.data;
const getNewsKey = (newsItem, index) => newsItem?._id ?? newsItem?.id ?? `news-${index}`;

function NewsPage() {
  const {
    items: news,
    loading,
    loadingMore,
    error,
    hasMore,
    sentinelRef,
    reload,
  } = useInfiniteList({
    endpoint: '/view-news-user',
    method: 'post',
    selectItems: selectNews,
    getKey: getNewsKey,
  });

  return (
    <main className={classes.eventsPage}>
      <PageHeader
        eyebrow="Latest"
        title="News"
        image={img}
        meta={news.length > 0 ? `${news.length} shown` : undefined}
      />
      <section className={classes.mainContainer}>
        <div className={classes.gridContainer}>
          {news.map((newsItem, index) => (
            <EventsCards key={getNewsKey(newsItem, index)} data={newsItem} name={'news'} />
          ))}
        </div>

        <ListStatus
          sentinelRef={sentinelRef}
          loading={loading}
          loadingMore={loadingMore}
          error={error}
          hasMore={hasMore}
          isEmpty={news.length === 0}
          onRetry={reload}
          emptyLabel="No news to show yet."
          endLabel="No more news."
        />
      </section>
    </main>
  );
}

export default NewsPage;
